export default __webpack_public_path__ + "static/media/electricity-colored.4b671b5e.svg";